export default __webpack_public_path__ + "static/media/sentiment-neutral.bbc5db4e.svg";